import { render, staticRenderFns } from "./MessageLocation.vue?vue&type=template&id=c52648aa&scoped=true&"
import script from "./MessageLocation.vue?vue&type=script&lang=js&"
export * from "./MessageLocation.vue?vue&type=script&lang=js&"
import style0 from "./MessageLocation.vue?vue&type=style&index=0&id=c52648aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52648aa",
  null
  
)

export default component.exports